import { Dispatch, SetStateAction, CSSProperties } from 'react';
import { NetworkConnection } from '../common';
import { NumberPad } from './NumberPad';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDeleteLeft } from '@fortawesome/free-solid-svg-icons';


type TypeDialPadProps = {
  setDialedInput: Dispatch<SetStateAction<string>>;
  dialedInputStyle: CSSProperties;
  dialedInput: string;
  handleDisconnect: Function;
};

export function DialPad({
  setDialedInput,
  dialedInputStyle,
  dialedInput,
  handleDisconnect
}: TypeDialPadProps) {
  return (
    <>
      <NetworkConnection hangupHandler={handleDisconnect} />
      <div className="d-flex flex-row" style={{marginRight: "-50px"}}>
        <div className="dialer-output shadow-sm" style={dialedInputStyle}>
          <input
            className="border form-control text-center"
            value={dialedInput}
            onChange={(e) => {
              const allowed = e.target.value.replace(/[^\d*#]/g, '');
              setDialedInput(allowed)
            }}
            style={dialedInputStyle}
          />
        </div>
        <button
          type="button"
          className="btn dial-backspace shadow-sm ripple"
          onClick={() => {
            setDialedInput(prev => prev.slice(0, -1))
          }}
        >
          <FontAwesomeIcon
            icon={faDeleteLeft}
            className="mr-1 ml-1"
          />
        </button>
      </div>
      <NumberPad setDialedInput={setDialedInput} />
    </>
  );
}
